import { defineComponent as _defineComponent } from 'vue'
import LPHeaderMenuPc from '@/views/layouts/lpLayout/lpHeader/LPHeaderMenuPc.vue';
import LPHeaderMenuSp from '@/views/layouts/lpLayout/lpHeader/LPHeaderMenuSp.vue';

import { store } from '@/store/index';
import { dispatchSetUserLocale } from '@/store/main/actionsMain';
import { onMounted, onUnmounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LPHeader',
  setup(__props) {

const isScrolled = ref(false);
const drawerOpened = ref(false);

const changeLocale = (locale: string) => {
  dispatchSetUserLocale(store, locale);
};

const handleScroll = () => {
  isScrolled.value = window.scrollY > 80;
};

const handleToggleDrawer = (opened: boolean) => {
  drawerOpened.value = opened;
};

onMounted(async () => {
  window.addEventListener('scroll', handleScroll);

  const params = new URLSearchParams(location.href.split('?')[1]);
  const lang = params.get('lang');

  if (lang === 'en' || lang === 'en-US') {
    changeLocale('en-US');
  }
});

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
});

return { __sfc: true,isScrolled, drawerOpened, changeLocale, handleScroll, handleToggleDrawer, LPHeaderMenuPc, LPHeaderMenuSp }
}

})